// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TransactionOutlinedSvg from "@ant-design/icons-svg/es/asn/TransactionOutlined";
import AntdIcon from '../components/AntdIcon';

var TransactionOutlined = function TransactionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TransactionOutlinedSvg
  }));
};

TransactionOutlined.displayName = 'TransactionOutlined';
export default React.forwardRef(TransactionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TransactionOutlined.js
// module id = 1955
// module chunks = 0